import React from 'react';
import './ServiceHero.css';

const ServiceHero = ({
  kicker,
  title,
  description,
  bgImage,
  onConnectClick,
  onPdfClick,
  pdfText = "View PDF"
}) => {
  return (
    <section
      className="service-hero-section"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.35)), url(${process.env.PUBLIC_URL}${bgImage})`
      }}
    >
      <div className="service-hero-content">
        {kicker && <span className="service-hero-kicker">{kicker}</span>}
        <h1>{title}</h1>
        {description && <p>{description}</p>}
        <div className="service-hero-buttons">
          {onConnectClick && (
            <button className="btn-service-connect" onClick={onConnectClick}>
              Connect Now!
            </button>
          )}
          {onPdfClick && (
            <button className="btn-service-pdf" onClick={onPdfClick}>
              {pdfText}
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;
